/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_Scan_BtnInputs */



/**
* | output |
* | --- |
* | "Scan QR to Check In" |
*
* @param {Checkin_Qr_Scan_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_scan_btn = /** @type {((inputs?: Checkin_Qr_Scan_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_Scan_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scanner le QR pour pointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escanear QR para hacer check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Escanear QR para check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansiona QR per il check-in")
	return /** @type {LocalizedString} */ ("Scan QR to Check In")
});